// src/lib/shortId.js

const BASE64URL_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

export const uuidToShortId = (uuid) => {
    if (!uuid) return "";

    const hex = uuid.replace(/-/g, "").toLowerCase();

    if (!/^[0-9a-f]{32}$/.test(hex)) {
        throw new Error("Invalid UUID");
    }

    const bytes = new Uint8Array(16);

    for (let i = 0; i < 16; i++) {
        bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    }

    let bits = "";
    for (const byte of bytes) {
        bits += byte.toString(2).padStart(8, "0");
    }

    let output = "";
    for (let i = 0; i < bits.length; i += 6) {
        const chunk = bits.slice(i, i + 6).padEnd(6, "0");
        output += BASE64URL_ALPHABET[parseInt(chunk, 2)];
    }

    return output;
};

export const shortIdToUuid = (shortId) => {
    if (!shortId) return "";

    let bits = "";

    for (const char of shortId) {
        const value = BASE64URL_ALPHABET.indexOf(char);

        if (value === -1) {
            throw new Error("Invalid short ID");
        }

        bits += value.toString(2).padStart(6, "0");
    }

    const bytes = [];

    for (let i = 0; i < 128; i += 8) {
        bytes.push(parseInt(bits.slice(i, i + 8), 2));
    }

    const hex = bytes
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");

    return [
        hex.slice(0, 8),
        hex.slice(8, 12),
        hex.slice(12, 16),
        hex.slice(16, 20),
        hex.slice(20),
    ].join("-");
};